import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as watchlistManagerAPI from "../../actions/zoomboard/watchlistManager";
import WatchlistManagerAddMember from "./forms/WatchlistManagerAddMember";
import WatchlistManagerUpdateMember from "./forms/WatchlistManagerUpdateMember";
import WatchlistTable from "./tables/WatchlistTable";
import Button from "@mui/material/Button";
import FormWrapper from "../common/form/FormWrapper";
import Form from "../common/form/Form";
import PopMessage from "../common/messages/PopMessage";
import stateConfig from "../../config/state";

function WatchlistManager({ watchlist, watchlistManagerAPI }) {
  const [init, setInit] = useState(false);
  const [displayForm, setDisplayForm] = useState(null);
  const [memberInfo, setMemberInfo] = useState(null);
  const [error, setError] = useState(null);
  const [submission, setSubmission] = useState(false);

  const MEMBER_TYPES = [
    { type: "board-member", title: "Board Members"},
    { type: "ecclesiastical-board-member", title: "Ecclesiastical Board Members" },
    { type: "large-donor", title: "Large Donors" },
    { type: "long-time-member", title: "Long-time Members" },
    { type: "other", title: "Other" }
  ]

  useEffect(() => {
    if(!init) {
      watchlistManagerAPI.getWatchlist();
      setInit(true);
    };
  }, [init, watchlistManagerAPI]);

  useEffect(() => {
    if (watchlist.responseStatus === stateConfig.responseStatus.ERROR) {
      setError(watchlist.responseErr);
    }
  }, [watchlist.responseStatus, watchlist.responseErr]);
  
  const handleAddMember = () => setDisplayForm("create");
  
  const handleEdit = (member) => {
    setMemberInfo(member);
    setDisplayForm("update");
  }

  const handleDelete = (member) => {
    setMemberInfo(member);
    setDisplayForm("delete");
  };

  const confirmDelete = async (event) => {
    event.preventDefault();
    setSubmission(true);

    const deleted = await watchlistManagerAPI.deleteWatchlistMember(memberInfo._id);
    setSubmission(false);
    if (!deleted) return;

    handleCloseForm();
  };

  const handleCloseForm = () => setDisplayForm(null);

  const clearPopMessage = () => setError(null);

  const sortedMembers = [...watchlist.watchlistMembers].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="WatchlistManager">
      <div className="watchlist-heading">
        <h1>Zoomboard Watchlist Manager</h1>
        <Button color="primary" variant="contained" onClick={handleAddMember}>Add member</Button>
      </div>

      { MEMBER_TYPES.map(({ type, title }) => (
        <WatchlistTable 
          key={type}
          title={title}
          members={sortedMembers.filter((member) => (member.type === type))}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      ))}

      { displayForm === "create" && (
        <WatchlistManagerAddMember onClose={handleCloseForm} members={watchlist.watchlistMembers} />
      )}

      { displayForm === "update" && (
        <WatchlistManagerUpdateMember onClose={handleCloseForm} member={memberInfo} members={watchlist.watchlistMembers} />
      )}

      { displayForm === "delete" && (
        <div className="WatchlistManager-overlay">
          <div className="WatchlistManager-form">
            <FormWrapper squared={true} raised={true}>
              <h2>Confirm Member Delete</h2>
              <Form
                id="MemberDelete-form"
                onSubmit={confirmDelete}
                onClickSecondary={handleCloseForm}
                submitLabel="Delete"
                submission={submission}
                autoComplete="off"
              >
                <div className="delete-confirmation">
                  <h3>You are about to remove the following member from the Watchlist:</h3>
                  <div>
                    <p>Name: {memberInfo.name}</p>
                    <p>Email: {memberInfo.email}</p>
                    <p>Type: {memberInfo.type}</p>
                    <p>Notes: {memberInfo.notes}</p>
                  </div>
                </div>
              </Form>
            </FormWrapper>
          </div>
        </div>
      )}

      {error !== null &&
        <PopMessage horizontal="center" open={true} onClose={clearPopMessage}
          type={stateConfig.messageTypes.ERROR}>
          <p>
            There was an error with your request. Please try again.<br/>
            {error?.code && error?.message ? `ERROR: ${error.code} - ${error.message}` : ""}
          </p>
        </PopMessage>
      }
    </div>
  )
}

function mapStateToProps(state) {
  return {
    watchlist: state.watchlist,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    watchlistManagerAPI: bindActionCreators(watchlistManagerAPI, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WatchlistManager);